function nextSlide(selector) {
    const slides = document.querySelectorAll(`${selector} > .slide`);
    let activeSlideIndex = 0;

    if (slides.length > 1) {
        for (const [key, slide] of Object.entries(slides)) {
            if (slide.classList.contains('active')) {
                activeSlideIndex = parseInt(key);
            }
        }
        const newActiveSlideIndex = ((activeSlideIndex + 1) >= slides.length) ? 0 : activeSlideIndex + 1;
        const img = slides[newActiveSlideIndex].querySelector('img');

        if (img.src !== img.getAttribute('data-src')) {
            //load src
            img.src = img.getAttribute('data-src');
        }

        //change slide
        slides[activeSlideIndex].classList.remove('active');
        slides[newActiveSlideIndex].classList.add('active');

        setTimeout(() => { nextSlide(selector); }, 5000);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const heroSelector = '.hero--slider';
    const heroSlider = document.querySelector(heroSelector);

    if (heroSlider) {
        setTimeout(() => { nextSlide(heroSelector); }, 5000);
    }
});